
























































import Vue from "vue";
import {AuthUserRequest, ErrorResponse, ForgotPasswordRequest, FormField} from "../../../../types";
import {Component} from "vue-property-decorator";
import AuthService from "../../../services/AuthService";

@Component({
    components: {},
    props: {}
})

export default class Authorization extends Vue {
    private successAuth: boolean = false;
    private forgotPassword: boolean = false;
    private successResetPassword: boolean = false;

    private formFields: Array<string> = [
        'email',
        'password',
    ];

    private email: FormField = {
        id: 'email',
        name: 'email',
        type: 'text',
        label: '',
        value: '',
        success: true,
        error: null,
        placeholder: 'Введите Email',
    };

    private password: FormField = {
        id: 'password',
        type: 'password',
        name: 'password',
        value: '',
        label: '',
        error: null,
        success: false,
        placeholder: 'Введите пароль',
    };

    /**
     * Отправка формы авторизации
     */
    private submitLoginForm(): void
    {
        const params: AuthUserRequest = {
            email: this.email.value as string,
            password: this.password.value as string,
        };

        this.$userAuthApi.authUserRequest(params).then((response: any) => {
            if (response.token) {
                const date = new Date(new Date().getTime() + 180 * 24 * 60 * 60 * 1000);
                AuthService.setUserToken(response.token, date);

                window.location.href = '/statistics';
            }
        }).catch((error: ErrorResponse) => {
            if (error.code === this.$errorApi.ERROR_VALIDATION) {
                this.clearValidationErrors();
                this.showValidationErrors(error.message);
            }
        });
    }

    /**
     * Очищает ошибки валидации
     */
    private clearValidationErrors(): void
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.error = null;
        });
    }

    /**
     * Показать ошибки валидации
     */
    private showValidationErrors(errors: any)
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.success = true;

            for (let attribute in errors) {
                if (errors[attribute].length > 0 && typeof errors[attribute][0] !== 'undefined') {
                    const errorMessage = errors[attribute][0];
                    if (field.name === attribute) {
                        field.error = errorMessage;
                        field.success = false;
                    }
                }
            }
        });
    }

    /**
     * Отправка формы восстановления пароля
     * @private
     */
    private submitForgotForm(): void
    {
        const params: ForgotPasswordRequest = {
            email: this.email.value as string,
        };

        this.$userAuthApi.forgotPasswordRequest(params).then((response: any) => {
            if (response.success) {
                this.successResetPassword = true;
            }
        }).catch((error: ErrorResponse) => {
            if (error.code === this.$errorApi.ERROR_VALIDATION) {
                this.clearValidationErrors();
                this.showValidationErrors(error.message);
            }
        });
    }
}

